// src/lib/unregisterServiceWorker.js

export function unregisterServiceWorkers() {
  if ('serviceWorker' in navigator) {
    if (navigator.serviceWorker.getRegistrations) {
      navigator.serviceWorker
        .getRegistrations()
        .then((registrations) => {
          for (const registration of registrations) {
            registration.unregister().then((boolean) => {
              console.log('Service Worker unregistered:', boolean);
            });
          }
        })
        .catch((error) => {
          console.error('Error unregistering service workers:', error);
        });
    } else if (navigator.serviceWorker.getRegistration) {
      navigator.serviceWorker
        .getRegistration()
        .then((registration) => {
          if (registration) {
            registration.unregister().then((boolean) => {
              console.log('Service Worker unregistered:', boolean);
            });
          }
        })
        .catch((error) => {
          console.error('Error unregistering service worker:', error);
        });
    }
  }
}
  